import { Link } from "react-router-dom";
import { EmeraldCosmos } from "./PhysicsImage";
import { useSEO } from "@/lib/useSEO";
import { DisciplineSwitcher } from "@/components/academy/DisciplineSwitcher";

export default function PhysicsFrame({ title, crumb, children, testid, canonicalPath = "", draftGuard }) {
  useSEO({
    title: `${title} | Stoic Physics | StoicOs.ai Academy`,
    canonical: `https://stoicos.ai/academy/physics${canonicalPath}`,
  });
  return (
    <main className="min-h-screen bg-ink px-6 sm:px-10 py-24" data-testid={testid}>
      <div className="max-w-4xl mx-auto">
        <DisciplineSwitcher active="physics" draftGuard={draftGuard} />
        <nav aria-label="Breadcrumb" className="text-[10px] tracking-[0.25em] uppercase text-[#7fb69a] mb-10">
          <Link to="/academy" className="hover:text-gold">Academy</Link> / <Link to="/academy/physics" className="hover:text-gold">Stoic Physics</Link> / <span className="text-fog">{crumb || title}</span>
        </nav>
        <div className="flex items-center gap-4 mb-8"><EmeraldCosmos size={36} /><h1 className="font-serif text-3xl sm:text-4xl text-bone">{title}</h1></div>
        {children}
      </div>
    </main>
  );
}
